module.exports = __webpack_public_path__ + "assets/img/rule-4.7b12db86.png";